import { h, Component } from 'preact';

let frozen = false;

// For testing purposes only
export function freezeIDCounter() {
	if (process.env.NODE_ENV !== 'production') {
		frozen = true;
	}
}

const A11Y_ID_COUNTERS = {};

export default function ariaIDProvider(baseName) {
	A11Y_ID_COUNTERS[baseName] = (A11Y_ID_COUNTERS[baseName] || 0) + 1;

	return function(Child) {
		return class AriaIDProvider extends Component {
			constructor() {
				super();
				if (!frozen) {
					A11Y_ID_COUNTERS[baseName] += 1;
				}

				this.a11yId = `${baseName}_${A11Y_ID_COUNTERS[baseName]}`;
			}

			render(props) {
				return <Child {...props} a11yId={this.a11yId} />;
			}
		};
	};
}




// WEBPACK FOOTER //
// ../node_modules/@cube/location-widget/src/components/a11y/provider.js